import { ACCOUNTS_ACTIONS } from '../accounts/accounts.constants';
import { INTEGRATION_ACTIONS } from '../integrations/integrations.constants';
import { TEAMS_ACTIONS } from '../teams/teams.constants';
import { USER_GROUPS_ACTIONS } from '../userGroups/userGroups.constants';
import { myToastService } from '../../v5/services/front/ToastService/ToastService.connected.js';
import mapAlertError from '../../v1/helpers/alertErrors';
import { emitServerUnreachable } from '../../v5/platform/server-unreachable/serverUnreachableEvent';

/**
 * RTK thunks dispatched together when an authenticated session loads (see Routes.jsx).
 * Any bootstrap failure means the app cannot start — show the full-page
 * server-unreachable screen instead of a toast behind the loading spinner.
 */
const BOOTSTRAP_SERVER_UNREACHABLE_REJECTED = new Set([
  `${TEAMS_ACTIONS.getAccountTeams}/rejected`,
  `${ACCOUNTS_ACTIONS.getTeamAccounts}/rejected`,
  `${USER_GROUPS_ACTIONS.getTeamUserGroups}/rejected`,
  `${INTEGRATION_ACTIONS.getIntegrations}/rejected`
]);

function tryEmitBootstrapServerUnreachable(action) {
  if (
    BOOTSTRAP_SERVER_UNREACHABLE_REJECTED.has(action.type) &&
    !action.meta?.aborted
  ) {
    emitServerUnreachable(action.error, 'bootstrap');
    return true;
  }
  return false;
}

const rejectedToastMiddleware = () => next => action => {
  const type = action && action.type;
  if (typeof type === 'string' && type.endsWith('/rejected')) {
    // Bootstrap rejections show the full-page screen; skip the error toast.
    if (tryEmitBootstrapServerUnreachable(action)) {
      return next(action);
    }

    const raw = (action.error && (action.error.message || action.error)) || '';
    const message =
      (typeof raw === 'string' && (mapAlertError(raw) || raw)) ||
      (raw && raw.message) ||
      'Sorry something has gone wrong';
    myToastService.open({ type: 'error', message: String(message) });
  }
  return next(action);
};

export default rejectedToastMiddleware;
